<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M3.23,786.14l0.91,1.82l-0.91,0.91h-5.45l-0.91-0.91l0.91-1.82H3.23L3.23,786.14z M6.86,789.77l2.73,3.64h0.91v1.82H9.43
	c0.1,0.27,0.16,0.58,0.16,0.91v0c0,1.51-1.22,2.73-2.73,2.73l0,0c-1.51,0-2.73-1.22-2.73-2.73l0,0c0-0.33,0.06-0.64,0.16-0.93
	l-0.01,0.02H3.23l-0.91,0.91h-3.64l-0.91-0.91H-3.3c0.1,0.27,0.16,0.58,0.16,0.91v0c0,1.51-1.22,2.73-2.73,2.73l0,0
	c-1.51,0-2.73-1.22-2.73-2.73l0,0c0-0.33,0.06-0.64,0.16-0.93l-0.01,0.02H-9.5v-1.82h0.91l2.73-3.64h1.82l1.82,0.91h5.45l1.82-0.91
	H6.86L6.86,789.77z"/>
</svg>

</template>